<template>
  <div v-if="show" id="wave-complete">
    <div class="wave-content">
      <h1 class="wave-title">WAVE {{ wave }} GEHAALD!</h1>
      <div class="confetti-container">
        <div v-for="i in 50" :key="i" class="confetti-piece" :style="getConfettiStyle(i)"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  wave: { type: Number, default: 1 }
});

const getConfettiStyle = (index) => {
  const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#ff8800', '#8800ff'];
  const color = colors[index % colors.length];
  const delay = Math.random() * 0.5;
  const duration = 2 + Math.random() * 1;
  const x = (Math.random() - 0.5) * 200;
  const rotation = Math.random() * 360;
  
  return {
    backgroundColor: color,
    left: `calc(50% + ${x}px)`,
    animationDelay: `${delay}s`,
    animationDuration: `${duration}s`,
    transform: `rotate(${rotation}deg)`
  };
};
</script>

<style scoped>
#wave-complete {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 250;
  pointer-events: none;
}

.wave-content {
  text-align: center;
  position: relative;
}

.wave-title {
  font-size: 5em;
  color: #ffaa00;
  text-shadow: 
    0 0 20px rgba(255, 170, 0, 0.8),
    0 0 40px rgba(255, 170, 0, 0.6),
    0 0 60px rgba(255, 170, 0, 0.4),
    0 0 80px rgba(255, 170, 0, 0.2);
  margin: 0;
  animation: wavePulse 0.5s ease-out;
  font-family: 'Arial', sans-serif;
  font-weight: bold;
}

@keyframes wavePulse {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.confetti-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.confetti-piece {
  position: absolute;
  width: 10px;
  height: 10px;
  top: 50%;
  left: 50%;
  animation: confettiFall linear forwards;
  opacity: 0;
}

@keyframes confettiFall {
  0% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translate(var(--tx, 0), var(--ty, 500px)) rotate(720deg);
    opacity: 0;
  }
}

.confetti-piece:nth-child(odd) {
  --tx: calc((var(--i, 0) - 25) * 20px);
  --ty: 600px;
}

.confetti-piece:nth-child(even) {
  --tx: calc((var(--i, 0) - 25) * -20px);
  --ty: 600px;
}
</style>


